module.exports = __webpack_public_path__ + "static/media/count-down.4434490e.jpeg";